import { Component, EventEmitter, Input, OnChanges, Output, signal } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Enums } from '../../../shared/enums';
import { Utils } from '../../../shared/utils';
import { IMPORTS } from './_imports';

@Component({
    selector: 'pdf-upload',
    templateUrl: './pdf-upload.component.html',
    styleUrl: './pdf-upload.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class PdfUploadComponent implements OnChanges {
    // #region [const]
    private MAX_SIZE_MB: number = 15;
    // #endregion

    // #region [signals]
    $disabled = signal(false);
    $fileName = signal(null as string);
    // #endregion

    // #region [Input/Output]
    @Input('disabled') _disabled: boolean;
    @Input('value') _value: any;
    @Output('valueChange') _valueChange = new EventEmitter<any>();
    // #endregion

    constructor(private toastr: ToastrService) { }

    ngOnChanges() {
        this.$disabled.set(this._disabled);
    }

    changeFile(event) {
        const file = event.target.files[0] as File;

        // caso a extensão do arquivo não seja PDF
        if (file.name.split('.').slice(-1)[0].toLowerCase() != 'pdf') {
            // reinicia valores do input e do componente Formio
            this.removeFile(event);
            this.toastr.error(Enums.Messages.PdfFilesOnly, Enums.Messages.Error, Utils.getToastrErrorOptions());
            return;
        }

        // caso o tamanho do arquivo seja maior que o máximo estabelecido
        if (file.size > this.MAX_SIZE_MB * 1024 * 1024) {
            // reinicia valores do input e do componente Formio
            this.removeFile(event);
            this.toastr.error(Enums.Messages.PdfMaxSizeLimit.replace('{0}', this.MAX_SIZE_MB.toString()), Enums.Messages.Error, Utils.getToastrErrorOptions());
            return;
        }

        let fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);
        fileReader.onloadend = () => {
            // converte o arquivo para um array de bytes, uma vez que o "JSON.stringify > JSON.parse"
            // que ocorre no meio do caminho até o hook do evento de submit do Formio
            // transformaria o objeto do tipo File em um objeto vazio ("{}")
            let byteArray = [];
            let array = new Uint8Array(fileReader.result as ArrayBuffer);
            for (let byte of array) {
                byteArray.push(byte);
            }

            this.$fileName.set(file.name);
            this._value = {
                isCustomFileComponent: true,
                fileName: [file.name],
                fileType: [file.type],
                fileContent: [byteArray]
            };
            this._valueChange.emit(this._value);
        };
    }

    removeFile(event) {
        event.target.value = '';
        this.$fileName.set(null);
        this._value = {};
        this._valueChange.emit(this._value);
    }

    // #region [===== private methods =====]
    // #endregion
}
